import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { UserRoleType } from '../interfaces/User';
import Unauthorized from '../pages/Unauthorized';
import { Loading } from '../components';

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles?: UserRoleType[];
  requiredPermissions?: string[];
  requireAll?: boolean;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ 
  children, 
  allowedRoles = [], 
  requiredPermissions = [],
  requireAll = false 
}) => {
  const { user, role, hasPermission, hasRole, loading } = useAuth();

  if (loading) {
    return <Loading text="Verificando permissões..." />;
  }

  if (!user || !role) {
    return <Unauthorized />;
  }

  const hasRoleAccess = allowedRoles.length === 0 || allowedRoles.some(allowedRole => hasRole(allowedRole));
  const hasPermissionAccess = requiredPermissions.length === 0 || (requireAll 
    ? requiredPermissions.every(permission => hasPermission(permission))
    : requiredPermissions.some(permission => hasPermission(permission)));

  if (!hasRoleAccess || !hasPermissionAccess) {
    return <Unauthorized />;
  }

  return <>{children}</>;
};

export default RoleGuard;